import * as React from "react";
import { required, SelectInput, TextInput } from "react-admin";
import Transformer from "src/common/Transformer";
import { MakerFilterEditComponent } from "./MakerFilterComponent";
import { Edit, SimpleForm } from "src/enterprise/ra-rbac";
import { Grid } from "@mui/material";

export const MakerFilterEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "createdAt", "updatedAt"],
      update: {},
    });

    return data;
  };

  return (
    <Edit
      component={MakerFilterEditComponent}
      mutationMode="pessimistic"
      transform={transform}
    >
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} md={6}>
            <TextInput disabled source="id" />
          </Grid>
          <Grid item sm={12} md={6}>
            <TextInput source="code" validate={required()} />
          </Grid>
          <Grid item sm={12} md={6}>
            <TextInput source="name" validate={required()} />
          </Grid>
          <Grid item sm={12} md={6}>
            <SelectInput
              source="type"
              choices={[
                { id: "type", name: "Type" },
                { id: "region", name: "Region" },
              ]}
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
